// -------------------------------------------------------------------------
// NOTE: The name of the events that are dispatched from the payment iframe
// need to be unique to ensure that they do not get confused with other
// message events. This is particularly important with our resize logic
// where products that the payment iframe are embedded into also send resize
// events to the webpage in which they are embedded.
// -------------------------------------------------------------------------

/**
 *
 * @description The event that is dispatched whenever we need to resize the
 * payment iframe.
 * @returns {string}
 */
export const getPaymentIframeResizeEventName = () => "paymentIframeResize";

/**
 *
 * @description The event that is dispatched to the payment iframe requesting
 * a new card token during form submission.
 * @returns {string}
 */
export const getPaymentIframeSubmissionEventName = () =>
    "paymentIframeSubmission";

/**
 *
 * @description The event that is dispatched to the payment iframe that allows
 * the payment iframe to freely send post messages back to the host application
 * in a way that prevents CORS issues on custom domains.
 * @returns {string}
 */
export const getPaymentIframeHandshakeEventName = () =>
    "paymentIframeHandshake";

/**
 * @returns {string}
 */
export const getIdOfPaymentIframe = () => "payment-iframe";

/**
 *
 * @returns {string}
 */
export const getIdOfPaymentIframeContainer = () => "payment-iframe-container";

/**
 *
 * @description Iframes have a content window and we need to access it in order
 * to send a post messages to the payment iframe.
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
 * @returns {HTMLIFrameElement | null}
 */
export const getPaymentIframeElement = () => {
    const idOfPaymentIframe = getIdOfPaymentIframe();
    /** @type {HTMLIFrameElement | null} */
    const paymentIframe = document.querySelector(`#${idOfPaymentIframe}`);

    return paymentIframe;
};

/**
 *
 * @description Uses QGIV_HOST as the payment iframe should always be hosted on
 * a Qgiv domain. This is true even when the form is deployed on a custom domain.
 * @param {object} settings
 * @param {boolean} settings.isCms
 * @param {number} settings.formId
 * @param {string} settings.originOfPaymentIframe
 * @returns {string}
 */
export const getUrlOfPaymentIframe = ({
    formId,
    isCms,
    originOfPaymentIframe,
}) => {
    const formIdParam = `formId=${formId}`;
    const cmsParam = `isCms=true`;
    let src = `${originOfPaymentIframe}/api/v1/payment/paymentInitialState?${formIdParam}`;

    // Once this param is passed the BE always returns a value of true
    if (isCms) {
        src = `${src}&${cmsParam}`;
    }

    return src;
};

/**
 *
 * @param {boolean} hasBillingNameField
 * @returns {string}
 */
export const getDefaultHeightOfPaymentIframe = (hasBillingNameField) => {
    const heightWithBillingName = "231px";
    const heightWithoutBillingName = "159px";
    const defaultHeightOfPaymentIframe = hasBillingNameField
        ? heightWithBillingName
        : heightWithoutBillingName;

    return defaultHeightOfPaymentIframe;
};
